import { Component, OnInit, ViewChild, AfterViewChecked, AfterViewInit } from '@angular/core'
import { CpmService } from '../../service/cpm.service'
import { CompanyHeaderComponent } from 'app/securities-level/company-header/company-header.component'
import { Subscription } from 'rxjs/Subscription'
import { ActivatedRoute } from '@angular/router'
import { environment } from '../../../environments/environment'
import { StoreService } from '../../service/store.service'
import { AuthorizeService } from '../../service/authorize.service'
import { distinctUntilChanged } from '../../../../node_modules/rxjs/operator/distinctUntilChanged'
import { FreeFloatComponent } from '../free-float/free-float.component';
import { MajorShareholderComponent } from '../major-shareholder/major-shareholder.component';
import { DatePipe } from '@angular/common'
@Component({
  selector: 'app-board-shareholder',
  templateUrl: './board-shareholder.component.html',
  styleUrls: ['./board-shareholder.component.scss']
})
export class BoardShareholderComponent implements OnInit, AfterViewInit {
  symbolSearch
  companyProfile
  securityStatistic
  signPostin
  bodList
  bodSize
  getPrint
  @ViewChild(FreeFloatComponent) freeFloatComponent: FreeFloatComponent
  @ViewChild(MajorShareholderComponent) majorShareholderComponent: MajorShareholderComponent
  @ViewChild('companyHeaderComponent')
  companyHeaderComponent: CompanyHeaderComponent
  subscription: Subscription
  print = false
  pdf = false
  symbol
  displayHeader
  printPage
  freeFloat
  majorShare
  constructor(
    private cpmService: CpmService,
    private store: StoreService,
    private activatedRoute: ActivatedRoute,
    private authorization: AuthorizeService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    const { symbol } = this.activatedRoute.snapshot.params
    const { pdf, print } = this.activatedRoute.snapshot.data
    this.getPrint = print

    pdf === undefined ? (this.pdf = false) : (this.pdf = pdf)
    print === undefined ? (this.print = false) : (this.print = print)

    if (symbol) {
      this.cpmService.getSecurityProfileNew(symbol)
    }

    if (this.print || this.pdf) {
      this.printPage = true
    } else {
      this.printPage = false
    }
    this.getDetailBoardShareholder()
  }

  get isUserHasPermission(): Boolean {
    return this.authorization.hasRole('ROLE_USER')
  }

  getDetailBoardShareholder() {
    this.store.getSecurityProfileNewResultObservable().subscribe(response => {
      if (!response) {
        return
      }
      this.companyProfile = response
      this.symbol = response['securitySymbol']
      this.getSignPosting(this.companyProfile.securitySymbol)
      this.getBODList(this.companyProfile.securitySymbol)
      if (this.freeFloatComponent) {
        const defFreeFloat = this.freeFloatComponent.selectedFreeFloatAsOfDate
        this.freeFloatComponent.asOfControl.valueChanges.subscribe(freeFloat => {
          this.freeFloat = freeFloat
        })
        if (this.freeFloat === undefined) {
          this.freeFloat = defFreeFloat
        }

      }
      if (this.majorShareholderComponent) {
        const defMajor = this.majorShareholderComponent.selectedMajorShareAsOf
        this.majorShareholderComponent.asOfControl.valueChanges.subscribe(majorShare => {
          this.majorShare = majorShare
        })
        if (this.majorShare === undefined) {
          this.majorShare = defMajor
        }
      }
    })
  }

  async getSecurityStatistic(searchInput) {
    await this.cpmService.getSecurityStatistic(searchInput).then(
      obj => {
        obj.map(security => {
          this.securityStatistic = security
        })
      },
      err => {
        return null
      }
    )
  }

  async getSignPosting(symbol) {
    const signList = []
    let cashBalance

    await this.cpmService.getSignPosting('sort', symbol).then(sign => {
      sign.map(signType => {
        isNaN(Number(signType.type))
          ? signList.push(signType.type)
          : (cashBalance = Number(signType.type))
      })
    })
    const signP = {}
    signP['sign'] = signList.join(',')
    signP['cashBalance'] = cashBalance
    this.signPostin = signP
  }
  async getBODList(symbol) {
    await this.cpmService.getBODList(symbol).then(bods => {
      this.bodList = bods
    })
    this.bodSize = this.bodList.bod.length - this.bodList.noOfAcid
  }

  exportPrint = function (symbol, freeFloat, majorShare) {
    return function executiveSummaryPrint() {
      const endcodeSymbol = encodeURIComponent(symbol)
      const popupWin = window.open(
        `/#/boardShareholder/${endcodeSymbol}/${freeFloat}/${majorShare}`,
        '_blank',
        'width=850px,height=1024px'
      )
    }
  }

  exportPdf = function (symbol, freeFloat, majorShare) {
    const service = this.cpmService
    return function boardStructurePdf() {
      const endcodeSymbol = encodeURIComponent(symbol)
      service.downloadFile(
        // tslint:disable-next-line:max-line-length
        `${environment.cpmBaseUrl}/pdf/boardShareholder?symbol=${endcodeSymbol}&freeFloat=${freeFloat}&majorShare=${majorShare}`
      )
    }
  }

  exportEmail = function (symbol, service, freeFloat, majorShare) {
    return function mailsectorPopup() {
      const endcodeSymbol = encodeURIComponent(symbol)
      service.saveboardShareholderPdfFile(endcodeSymbol, freeFloat, majorShare).then(filename => {
        const subject = 'Board and shareholder'
        const downloadUrl = encodeURIComponent(
          `${environment.cpmBaseUrl}/download?type=report&filename=${filename}`
        )
        window.location.href = `mailto:?subject=${subject}&body=${downloadUrl}`
      })
    }
  }

  exportFunctions() {
    const arrayOfFunctions: Map<String, Function> = new Map<String, Function>()
    arrayOfFunctions.set('email', this.exportEmail(this.symbol, this.cpmService,
      this.dateFormat(this.freeFloat),
      this.dateFormat(this.majorShare)))
    arrayOfFunctions.set('print', this.exportPrint(this.symbol,
      this.dateFormat(this.freeFloat),
      this.dateFormat(this.majorShare)))
    arrayOfFunctions.set('pdf', this.exportPdf(this.symbol,
      this.dateFormat(this.freeFloat),
      this.dateFormat(this.majorShare)))
    return arrayOfFunctions
  }

  displayPrintOrPdf() {
    return this.print || this.pdf
  }

  ngAfterViewInit() {
    if (this.getPrint) {
      window.setTimeout('window.print()', 3000);
    }
  }
  dateFormat(date) {
    date = this.datePipe.transform(date, 'yyyy-MM-dd')
    return date
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/board-shareholder/board-shareholder.component.ts